import { Box } from "@mui/material"
import ProntoLogoIcon from "../../../assets/images/ProntoLogo.png"

type Props = {}

const FullPageInitializer = (props: Props) => {
  return (
    <Box
      className="breathing-logo"
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img height={"100px"} src={ProntoLogoIcon} alt="" />
    </Box>
  )
}

export default FullPageInitializer
